import { useContext, useState } from 'react';
import { cn } from '@/helpers/utils/functionality-utils';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { LayoutContext } from '@/layout/context/context';

const ResetPage = () => {
  const { layoutConfig, theme } = useContext(LayoutContext);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const containerClassName = cn(
    'flex min-h-screen min-w-[100vw] items-center justify-center overflow-hidden bg-surface-50',
    { 'p-input-filled': layoutConfig.inputStyle === 'filled' },
  );

  return (
    <div className={containerClassName}>
      <div className="flex flex-col items-center justify-center">
        <img
          src={`/assets/images/logo/logo-${
            theme === 'light' ? 'dark' : 'light'
          }-512.png`}
          alt="Sakai logo"
          style={{ height: '200px', width: '200px' }}
          className="mb-8 shrink-0"
        />

        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)',
          }}
        >
          <div
            className="smpx-8 w-full bg-surface-0 px-8 py-8"
            style={{ borderRadius: '53px' }}
          >
            <div className="mb-8 text-center">
              <span className="text-lg font-bold leading-10 text-surface-600">
                Verify Password
              </span>
            </div>

            <div className="flex flex-col gap-4">
              <div>
                <label
                  htmlFor="code"
                  className="font-sm mb-2 block text-sm text-surface-900"
                >
                  6-digit Code
                </label>
                <InputText
                  id="code"
                  type="text"
                  placeholder="Enter verification code"
                  className="w-full md:w-[25rem]"
                  style={{ padding: '0.7rem' }}
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>

              <div>
                <label
                  htmlFor="newPassword"
                  className="font-sm mb-2 block text-sm text-surface-900"
                >
                  New Password
                </label>
                <InputText
                  id="newPassword"
                  type="password"
                  placeholder="Enter new password"
                  className="w-full md:w-[25rem]"
                  style={{ padding: '0.7rem' }}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              <div>
                <label
                  htmlFor="confirmPassword"
                  className="font-sm mb-2 block text-sm text-surface-900"
                >
                  Confirm Password
                </label>
                <InputText
                  id="confirmPassword"
                  type="password"
                  placeholder="Confirm your password"
                  className="w-full md:w-[25rem]"
                  style={{ padding: '0.7rem' }}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <Button
                label="Request to send code"
                className="text-l w-full p-4 md:w-[25rem]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPage;
